module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclamation-6b9f40da.svg";